import React from 'react';
import PropTypes from 'prop-types';

export default function IconKeyFilled({
  className,
  // style = {}
}) {
  return (
    <svg className={className} fill="none" height="42" viewBox="0 0 40 42" width="40" xmlns="http://www.w3.org/2000/svg">
      <rect fill="#EBF1E1" height="40" rx="15" width="40" y="1"/>
      <path d="M16.9492 17.5998C16.9492 13.9856 19.885 11.0498 23.4992 11.0498C27.0963 11.0498 30.0492 13.8687 30.0492 17.4998C30.0492 21.114 27.1134 24.0498 23.4992 24.0498C22.9689 24.0498 22.4451 23.9738 21.9484 23.846C21.9241 24.515 21.3741 25.0498 20.6992 25.0498H18.9492V26.7998C18.9492 27.4902 18.3896 28.0498 17.6992 28.0498H15.9492V29.2998C15.9492 30.2663 15.1657 31.0498 14.1992 31.0498H11.6992C10.7327 31.0498 9.94922 30.2663 9.94922 29.2998V27.1282C9.94922 26.3989 10.2389 25.6994 10.7547 25.1837L16.9905 18.9479C17.0449 18.8934 17.0775 18.8053 17.0597 18.7038C16.9994 18.3602 16.9492 17.987 16.9492 17.5998ZM26.2493 15.9998C26.2493 15.3095 25.6896 14.7498 24.9993 14.7498C24.3089 14.7498 23.7493 15.3095 23.7493 15.9998C23.7493 16.6902 24.3089 17.2498 24.9993 17.2498C25.6896 17.2498 26.2493 16.6902 26.2493 15.9998Z" fill="#5E811E"/>
    </svg>

  );
}

IconKeyFilled.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};
